import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { usePermission, useTranslation } from "src/hooks";
import { FeatureCodes } from "src/utils/constant";
import { useGenGridCol } from "src/utils/HelperComp";
import { TableColumnKey } from "../types/Table";
import useCopyableCell from "./useCopyableCell";
import useOpenLinkCell from "./useOpenLinkCell";
import useOperationCell from "./useOperationCell";

const useTableColumns = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();
  const { renderOperationCell, renderResubmitPrompter } = useOperationCell();
  const { renderCopyableCell } = useCopyableCell();
  const { renderOpenLinkCell } = useOpenLinkCell();

  const renderDialog = () => {
    return <>{renderResubmitPrompter()}</>;
  };

  const columns = [
    useGenGridCol(TableColumnKey.Operation, t(TableColumnKey.Operation), {
      renderCell: renderOperationCell,
      minWidth: 150,
    }),
    useGenGridCol(TableColumnKey.BatchId, t(TableColumnKey.BatchId)),
    useGenGridCol(TableColumnKey.MerchantName, t(TableColumnKey.MerchantName), {
      minWidth: 150,
    }),
    useGenGridCol(TableColumnKey.ChainName, t(TableColumnKey.ChainName)),
    useGenGridCol(TableColumnKey.Currency, t(TableColumnKey.Currency)),
    useGenGridCol(
      TableColumnKey.SmartAccountType,
      t(TableColumnKey.SmartAccountType),
      { minWidth: 120 },
    ),
    useGenGridCol(
      TableColumnKey.SpenderAddress,
      t(TableColumnKey.SpenderAddress),
      {
        renderCell: renderCopyableCell("spenderAddress"),
        minWidth: 300,
      },
    ),
    useGenGridCol(
      TableColumnKey.InvokerAddress,
      t(TableColumnKey.InvokerAddress),
      {
        renderCell: renderCopyableCell("invokerAddress"),
        minWidth: 300,
      },
    ),
    useGenGridCol(
      TableColumnKey.SpenderContractVersion,
      t(TableColumnKey.SpenderContractVersion),
      { minWidth: 150 },
    ),
    useGenGridCol(
      TableColumnKey.SpenderContractId,
      t(TableColumnKey.SpenderContractId),
      { minWidth: 150 },
    ),
    useGenGridCol(TableColumnKey.Status, t(TableColumnKey.Status)),
    useGenGridCol(TableColumnKey.TotalCount, t(TableColumnKey.TotalCount)),
    useGenGridCol(TableColumnKey.ClientData, t(TableColumnKey.ClientData)),
    useGenGridCol(TableColumnKey.CreationTime, t(TableColumnKey.CreationTime), {
      minWidth: 150,
    }),
    useGenGridCol(
      TableColumnKey.LastModifiedTime,
      t(TableColumnKey.LastModifiedTime),
      { minWidth: 150 },
    ),
    useGenGridCol(
      TableColumnKey.ViewOperation,
      t(TableColumnKey.ViewOperation),
      {
        renderCell: renderOpenLinkCell("operationRecords"),
      },
    ),
    useGenGridCol(
      TableColumnKey.ViewOperationTransaction,
      t(TableColumnKey.ViewOperationTransaction),
      {
        renderCell: renderOpenLinkCell("operationTransactionRecords"),
        minWidth: 160,
      },
    ),
    useGenGridCol(
      TableColumnKey.ViewTronRentResourceRecords,
      t(TableColumnKey.ViewTronRentResourceRecords),
      {
        renderCell: renderOpenLinkCell("tronRentResourceRecords"),
        minWidth: 190,
      },
    ),
  ].filter((col) => {
    if (
      col.field === TableColumnKey.Operation &&
      !hasPermission(
        FeatureCodes.assetManagement.BatchApproveAllowanceRequestRecord
          .Resubmit,
      )
    ) {
      return false;
    }
    if (
      col.field === TableColumnKey.ViewOperation &&
      !hasPermission(FeatureCodes.assetManagement.OperationRecords.prefix)
    ) {
      return false;
    }
    if (
      col.field === TableColumnKey.ViewOperationTransaction &&
      !hasPermission(
        FeatureCodes.assetManagement.OperationTransactionRecords.prefix,
      )
    ) {
      return false;
    }
    if (
      col.field === TableColumnKey.ViewTronRentResourceRecords &&
      !hasPermission(
        FeatureCodes.assetManagement.TronRentResourceRecords.prefix,
      )
    ) {
      return false;
    }
    return true;
  });
  return { columns, renderDialog };
};

export default useTableColumns;
